import BipRow from './BipRow';
import React from 'react';

function BIPAdministrator(props) {
  return (
    <div className="my-bip-container">
      <div className="bip-rows-container">
        {props.bipItems.map((val, key) => (
          <BipRow
            val={val}
            key={key}
            showBipEditPopup={props.showBipEditPopup}
            showBipDeletePopup={props.showBipDeletePopup}
            t={props.t}
          />
        ))}
      </div>
    </div>
  );
}

export default BIPAdministrator;



// WEBPACK FOOTER //
// ./src/features/my-account/MainTabsBodyMyAccount/components/BIPAdministrator.js